import React from 'react';

import { RouteComponent } from '@townsquare/router/RouteComponent';
import { SiteBannerProvider } from '@townsquare/site-banner';

export function EmbedRoute(): React.JSX.Element {
	return (
		<SiteBannerProvider>
			<RouteComponent />
		</SiteBannerProvider>
	);
}
